export const INITIAL_ACTION = 'INITIAL_ACTION'
export const GET_AUTOCOMPLETE = 'GET_AUTOCOMPLETE'
export const UPDATE_FORECASTS = 'UPDATE_FORECASTS'
export const UPDATE_CURRENT_WEATHER = 'UPDATE_CURRENT_WEATHER'
export const UPDATE_SELECTED_LOCATION = 'UPDATE_SELECTED_LOCATION'
export const TOGGLE_THEME = 'TOGGLE_THEME'
export const TOGGLE_UNIT = 'TOGGLE_UNIT'
export const ADD_FAVORITE = 'ADD_FAVORITE'
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT'
